<div class="rating">
  <div class="stars-empthy">
    <img class="star" *ngFor="let star of [].constructor(maxRating)" [src]="templateEmpthy" alt="*" />
  </div>

  <div class="stars-filled" [style.width]="(rate * 100) / maxRating + '%'">
    <img class="star" *ngFor="let star of [].constructor(maxRating)" [src]="templateFilled" alt="*" />
  </div>
</div>
